module.exports = __webpack_public_path__ + "img/three3Blue.e4e85bb9.jpg";